export default __webpack_public_path__ + "static/ht-a6146380e0ce351c15a3cc843fc6d328.svg";